import React, { useEffect, useState } from 'react';
import EditorViewer from './EditorViewer';
import DocFav from './DocFav';
import DocShare from './DocShare';
import RelationInfo from './RelationInfo';
import PopUp from './PopUp';
import { showToast } from './Messages';

const ContentViewer = (props) => {
    const [content, setContent] = useState(null);
    const [relatedDocument, setRelatedDocument] = useState('');
    const [isAddingManual, setIsAddingManual] = useState(false);
    const [localFolderList, setLocalFolderList] = useState(props.folderList);
    const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
    const [popupContent, setPopUpContent] = useState(null);
    const editorData = JSON.parse(props.editorData);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.context-menu') && !e.target.closest('.title-btns')) {
                setIsContextMenuOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        loadClickNodeContents();
        setRelatedDocumentContent();
    }, [props.ContentInfo.name, props.docId]);

    useEffect(() => {
        if (props.folderItemList.some((item) => item.manualId === props.manualId)) {
            setIsAddingManual(true);
        } else {
            setIsAddingManual(false);
        }
    }, [props.manualId])

    const loadClickNodeContents = () => {
        const docId = props.docId;
        if (!docId || !props.ContentInfo.item || !editorData) return;
        setContent(<EditorViewer ViewMode={true} editorData={editorData} folderName={props.class} docId={docId} />);
    };

    const setRelatedDocumentContent = async () => {
        const docId = props.docId;
        if (!docId) return;

        const response = await fetch('api/Document/GetRelatedDocumentsList', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify({ docId }),
        });

        const result = await response.json();
        if (result.data.table) {
            const relationData = JSON.parse(result.data.table[0].relationInfo ?? '[]');
            const faqData = JSON.parse(result.data.table[0].faq ?? '[]');
            setRelatedDocument(
                <RelationInfo relationInfo={relationData} faq={faqData} style={{ paddingBottom: "100px" }} />
            );
        } else {
            setRelatedDocument(null);
        }
    };

    const openContextMenu = (menuType) => {
        if (menuType === 'share') {
            setIsContextMenuOpen((prev) => !prev); // 토글 방식
        }
    };

    const copyLink = () => {
        const url = window.location.href;
        navigator.clipboard.writeText(url)
            .then(() => {
                setIsContextMenuOpen(false);
                showToast('success', '링크가 복사되었습니다.')
            })
            .catch((err) => {
                setIsContextMenuOpen(false);
                showToast('danger', '링크가 복사에 실패하였습니다.')
            });
    };

    const btnOnPopup = (e, type) => {
        if (e !== undefined) {
            e.stopPropagation();
        }
        if (type) {
            setPopUpContent(
                <Modal
                    type={type}
                    onClose={setPopUpContent}
                    setIsAddingManual={setIsAddingManual}
                    userId={props.devUserId}
                    manualId={props.manualId}
                    userName={props.devUserName}
                    companySeq={props.companySeq}
                    title={editorData.title}
                    folderList={localFolderList}
                    folderItemList={props.folderItemList}
                    setFolderList={setLocalFolderList}
                    setFolderItemList={props.setFolderItemList}
                    locationFrom={'contentViewer'}
                />
            );
        } else {
            setPopUpContent(null);
        }
    }

    return (
        <div className='doc-section'>
            <div className='editor-section'>
                <div className='title-section'>
                    <div className="title-btns-wrap">
                        <p>{props.ContentInfo.name}</p>
                        {props.devUserId !== '' && (
                            <div className="title-btns">
                                <button className='btn-share' onClick={() => openContextMenu('share')}>
                                    <i className='icoKdc16 share'></i>
                                    <i className='icoKdc12 dropdown-g'></i>
                                </button>
                                {isContextMenuOpen && (
                                    <div className="context-menu docview-pos sharelist">
                                        <ul className='sharelist-ul'>
                                            <li onClick={copyLink}>
                                                <button className="default">링크 복사</button>
                                            </li>
                                            <li onClick={(e) => { btnOnPopup(e, 'share'); setIsContextMenuOpen(false); }}>
                                                <button className="default">메일 공유</button>
                                            </li>
                                        </ul>
                                        <div className='sharelist-wrap'>
                                            <p className='sharelist-title'>이 문서의 공유 가능 대상</p>
                                            <ul className='sharelist-list'>
                                                {props.selectedAccess ? 
                                                    props.selectedAccess?.map((access, index) => {
                                                        return <li key={index}>{access.name}</li>
                                                    })
                                                :
                                                    <li>전체</li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                )}
                                <button className='btn-fav' onClick={(e) => btnOnPopup(e, 'fav')}>
                                    <i className={`icoKdc16 ${isAddingManual ? 'star-b' : 'star-g'}`}></i>
                                </button>
                            </div>
                        )}
                    </div>
                    <TagList tags={editorData.tag} />
                    <PopUp content={popupContent} setContent={setPopUpContent} />
                </div>
                <div className="manual-content">{content}</div>
                {relatedDocument}
            </div>
        </div>
    );
};

const Modal = (props) => {
    const { type } = props;

    switch (type) {
        case 'share':
            return <DocShare {...props} />;
        case 'fav':
            return <DocFav {...props} />;
        default:
            return null;
    }
};

const TagList = ({ tags }) => {
    if (!tags || tags.length === 0) return null;
    return (
        <ul className='tags'>
            {tags.map((tag, index) => (
                <li key={index} className='tag-each'>
                    {tag}
                </li>
            ))}
        </ul>
    );
};

export default ContentViewer;